import { css } from '@linaria/core';
export const Typo = {
    base: css `
		box-sizing: border-box;
		font-family: var(--typography-family-font-family), sans-serif;
		color: rgb(var(--text-color-body-01));

		a {
			color: inherit;
		}
	`,
    fonts: {
        monospace: css `
			font-family: 'Courier New', monospace;
			letter-spacing: 2px;
		`,
    },
    heading01: css `
		margin: 0;

		font-size: var(--typography-size-heading-01-rem);
		font-weight: var(--typography-weight-heading-01);
		line-height: var(--typography-line-height-heading-01-rem);
		letter-spacing: 0;
		overflow-wrap: break-word;
	`,
    heading02: css `
		overflow: hidden;
		display: inline-block;

		margin: 0 0 var(--text-spacing-heading-02);

		font-size: var(--typography-size-heading-02-rem);
		font-weight: var(--typography-weight-heading-02);
		line-height: var(--typography-line-height-heading-02-rem);
		text-overflow: ellipsis;
		letter-spacing: 0;
	`,
    heading03: css `
		overflow: hidden;
		display: block;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;

		width: 100%;
		-webkit-max-height: calc(1.5rem * 1.2 * 2);
		margin: 0 0 var(--text-spacing-heading-03);

		font-size: var(--typography-size-heading-03-rem);
		font-weight: var(--typography-weight-heading-03);
		line-height: var(--typography-line-height-heading-03-rem);
		text-overflow: ellipsis;
		letter-spacing: 0;
	`,
    heading04: css `
		margin: 0 0 var(--text-spacing-heading-04);

		font-size: var(--typography-size-heading-04-rem);
		font-weight: var(--typography-weight-heading-04);
		line-height: var(--typography-line-height-heading-04-rem);
		letter-spacing: 0;
	`,
    heading05: css `
		overflow: hidden;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;

		-webkit-max-height: calc(1.125rem * 1.2 * 2);
		margin: 0;

		font-size: var(--typography-size-heading-05-rem);
		font-weight: var(--typography-weight-heading-05);
		line-height: var(--typography-line-height-heading-05-rem);
		text-overflow: ellipsis;
		letter-spacing: 0;
	`,
    heading06: css `
		margin: 0;

		font-size: var(--typography-size-heading-06-rem);
		font-weight: var(--typography-weight-heading-06);
		line-height: var(--typography-line-height-heading-06-rem);
		letter-spacing: 0;
	`,
    body01: css `
		margin: 0;

		font-size: var(--typography-size-body-01-rem);
		font-weight: var(--typography-weight-body-01);
		line-height: var(--typography-line-height-body-01-rem);
		letter-spacing: 0;
	`,
    body02: css `
		margin: 0;

		font-size: var(--typography-size-body-02-rem);
		font-weight: var(--typography-weight-body-02);
		line-height: var(--typography-line-height-body-02-rem);
		letter-spacing: 0;
		white-space: pre-wrap;
	`,
    body03: css `
		margin: 0;

		font-size: var(--typography-size-body-03-rem);
		font-weight: var(--typography-weight-body-03);
		line-height: var(--typography-line-height-body-03-rem);
		letter-spacing: 0;
	`,
    label01: css `
		font-size: var(--typography-size-label-01-rem);
		font-weight: var(--typography-weight-label-01);
		line-height: var(--typography-line-height-label-01-rem);
		letter-spacing: 0;
	`,
    label02: css `
		font-size: var(--typography-size-label-02-rem);
		font-weight: var(--typography-weight-label-02);
		line-height: var(--typography-line-height-label-02-rem);
		letter-spacing: 0;
	`,
    label03: css `
		font-size: var(--typography-size-label-03-rem);
		font-weight: var(--typography-weight-label-03);
		line-height: var(--typography-line-height-label-03-rem);
		letter-spacing: 0;
	`,
    info01: css `
		font-size: var(--typography-size-info-01-rem);
		font-weight: var(--typography-weight-info-01);
		line-height: var(--typography-line-height-info-01-rem);
		letter-spacing: 0;
	`,
    info02: css `
		font-size: var(--typography-size-info-02-rem);
		font-weight: var(--typography-weight-info-02);
		line-height: var(--typography-line-height-info-02-rem);
		letter-spacing: 0;
	`,
    info03: css `
		font-size: var(--typography-size-info-03-rem);
		font-weight: var(--typography-weight-info-03);
		line-height: var(--typography-line-height-info-03-rem);
		letter-spacing: 0;
	`,
};
